import { useState, useEffect } from 'react';
// import { usePermissions } from '@/hooks/usePermissions'; // Removed
// import { useAuth } from '@/context/AuthContext'; // Removed
import { useAppSelector } from '@/store/hooks'; // Added
import { 
  selectUser, 
  selectAuthLoading, 
  selectHasPermission
} from '@/store/slices/authSlice'; // Corrected selector names

export function PermissionReminder({
  permissionName = 'user'
}: {
  permissionName?: string;
}) {
  // const { hasPermission } = usePermissions(); // Removed
  // const { currentUser, loading: authLoading } = useAuth(); // Removed
  const currentUser = useAppSelector(selectUser); // Corrected selector
  const authLoading = useAppSelector(selectAuthLoading) === 'pending'; // Added + check for 'pending' state
  const hasPermission = useAppSelector(selectHasPermission(permissionName as any)); // Use pre-defined selector

  // Add state to track if we should show the message
  const [showMessage, setShowMessage] = useState(false);
  
  // Add a delay before showing the message to prevent flashing during loading
  useEffect(() => {
    // Clear any existing timers when deps change
    let timer: NodeJS.Timeout;
    
    // Don't show message while loading
    if (authLoading) {
      setShowMessage(false);
      return () => clearTimeout(timer);
    }
    
    // If user has the permission, don't show the message
    if (hasPermission) {
      setShowMessage(false);
      return () => clearTimeout(timer);
    }
    
    // Only show the message after a delay if user lacks permission
    timer = setTimeout(() => {
      // Re-check conditions inside setTimeout as state might change
      if (!hasPermission && !authLoading) { 
        console.log('[PermissionReminder] User lacks permission, showing message');
        setShowMessage(true);
      }
    }, 3000); // 3 second delay
    
    return () => clearTimeout(timer);
  }, [permissionName, authLoading, hasPermission]); // Updated dependencies
  
  // Don't render anything while loading
  if (authLoading) {
    return null;
  }
  
  // Don't render if user has the permission
  if (hasPermission) {
    return null;
  }
  
  // Don't render if we shouldn't show the message yet
  if (!showMessage) {
    return null;
  }
  
  return (
    <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 my-4">
      <p className="font-bold">User permissions revoked</p>
      <p>
        You currently don't have the "{permissionName}" permission level.
        {currentUser ? (
          <span> Your account may need to be reviewed by an administrator.</span>
        ) : (
          <span> You need to sign in to access this feature.</span>
        )}
      </p>
    </div>
  );
}

export default PermissionReminder; 